var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39591 33.3867H31.6042C32.2363 33.3867 32.7605 33.9089 32.7605 34.5385C32.7605 35.1682 32.2363 35.6904 31.6042 35.6904H5.39591C4.76383 35.6904 4.23966 35.1682 4.23966 34.5385C4.23966 33.9089 4.76383 33.3867 5.39591 33.3867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2917 23.0516C28.6597 23.0516 28.1355 22.5294 28.1355 21.8997V8.90715L8.5255 28.4421C8.29425 28.6725 8.00133 28.78 7.70842 28.78C7.4155 28.78 7.12258 28.6725 6.89133 28.4421C6.44425 27.9967 6.44425 27.2596 6.89133 26.8142L26.5013 7.27924H13.4588C12.8267 7.27924 12.3026 6.75708 12.3026 6.12741C12.3026 5.49775 12.8267 4.97559 13.4588 4.97559H29.2917C29.4459 4.97559 29.5847 5.0063 29.7388 5.06773C30.0163 5.17524 30.2476 5.4056 30.3555 5.68204C30.4172 5.83562 30.448 5.97383 30.448 6.12741V21.8997C30.448 22.5294 29.9238 23.0516 29.2917 23.0516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.48168b77b1802cb418b4e066dde3230b.svg";
export { ForwardRef as ReactComponent };